import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Text } from '@uhg-abyss/web/ui/Text';

type Props = {
  message: string;
};

export const FilterSearchNoResults = ({ message }: Props) => (
  <Flex
    css={{
      padding: '$md',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <Text
      color="$core.color.neutral.80"
      data-auto-testid="filter-search-no-results"
      data-testid="filter-search-no-results"
    >
      {message}
    </Text>
  </Flex>
);
